import React from 'react';
import { styled } from '@mui/material';
import SquareRoundedIcon from '@mui/icons-material/SquareRounded';
import { sessionStatus } from 'common/constants/options';
import { AVAILABILITY_COLORS } from 'common/utils/availability';

// Leyenda de la página Disponibilidad: usa los MISMOS colores locales que los
// eventos del calendario (guardada = superficie neutra, no guardada = dorado).
const StyledAvailabilityStatusSquare = styled(({ status, ...otherProps }) => (
  <SquareRoundedIcon {...otherProps} />
))(({ status, theme }) => ({
  color: status === sessionStatus.scheduled ? AVAILABILITY_COLORS.saved : theme.palette.gold.main
}));

export default StyledAvailabilityStatusSquare;
